export const rollbarConfig = {
  accessToken: process.env.ROLLBAR_API_KEY,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.NODE_ENV,
  version: process.env.RAILWAY_GIT_COMMIT_SHA,

  payload: {
    environment: process.env.NODE_ENV,
    client: {
      javascript: {
        source_maps_enabled: true,
        code_version: process.env.RAILWAY_GIT_COMMIT_SHA,
      },
    },
    custom: {
      error_source: "frontend",
    },
  },
};
